<section>
  <div class="form-register">
    <form [formGroup]="formNoteDetail">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-6 col-12">
          <div class="row align-items-end">
            <div class="col-lg-1 col-md-3 col-sm-6 col-12" *ngIf="!isDocumentSupport">
              <app-custom-select formControlName="conceptInvoicingId" [labelText]="'Concepto Fra.'"
                [list]="listConceptInvoicing" [required]="true" (onChangeSelect)="getConceptInvoicing($event, true)">
              </app-custom-select>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-6 col-12" *ngIf="!isDocumentSupport">
              <app-custom-select formControlName="storeId" [labelText]="'Bodega'" [list]="listStore" [required]="true"
                (onChangeSelect)="getStore($event, true)">
              </app-custom-select>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-12" *ngIf="!isDocumentSupport">
              <app-custom-inputgroup [inputValue]="codeNameArticle" [labelText]="'Artículo'"
                [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar artículo'" [required]="true"
                (onClick)="openArticleModal()"></app-custom-inputgroup>
              <app-custom-modal #selectArticle [label]="'Nuevo'" [header]="'Selección de Articulos'"
                [inputs$]="inputsForArticlesSelect$" [output$]="output$" [children]="component"
                (selectedItems)="handleSelectedItems($event)" hidden></app-custom-modal>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-12" *ngIf="isDocumentSupport">
              <app-custom-inputgroup [inputValue]="codeNameArticle" [labelText]="'Artículo'"
                [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar artículo'" [required]="true"
                (onClick)="openArticleModal()"></app-custom-inputgroup>
              <app-custom-modal #selectArticle [label]="'Nuevo'" [header]="'Selección de Articulos'"
                [inputs$]="inputsForArticlesSelect$" [output$]="output$" [children]="component"
                (selectedItems)="handleSelectedItems($event)" hidden></app-custom-modal>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6" *ngIf="!isDocumentSupport">
              <app-custom-input-text formControlName="document" [labelText]="'Documento'"></app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6" *ngIf="!isDocumentSupport">
              <app-custom-input-text formControlName="accountingCostCenter" [labelText]="'C.Costo Cont.'"
                [required]="false" [maxLength]="10"></app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6" *ngIf="!isDocumentSupport">
              <app-custom-input-number formControlName="totalTime" [labelText]="'Días'" [required]="true"
                (onChangeNumber)="calculateTotalValue()"></app-custom-input-number>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6">
              <app-custom-input-number formControlName="quantity" [labelText]="'Cantidad'" [required]="true"
                (onChangeNumber)="changeQuantity()">
              </app-custom-input-number>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6">
              <app-custom-input-decimal formControlName="unitValue" [labelText]="'Vr.Unitario'" [required]="true"
                (onChangeNumber)="calculateTotalValue()"></app-custom-input-decimal>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6">
              <app-custom-input-decimal formControlName="totalValue" [labelText]="'Vr.Total'"
                [required]="true"></app-custom-input-decimal>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-3 col-6">
              <div class="d-flex justify-content-left container-buttons gap-1">
                <app-custom-button [title]="'Guardar Detalle'" [label]="'Guardar'" [severity]="'primary'"
                  (onClick)="send()"></app-custom-button>
                <app-custom-button [label]="'Cancelar'" [severity]="'danger'"
                  (onClick)="clearForm(false)"></app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>